module.exports = "/content/1e23428690d43bc8048de4b886b17638.png";